// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classnames from "classnames";
import {nothing} from "lit";
import Utils from "../../../../main/utils/index.js";

/**
 * Based on pn-www's Button component
 *
 * @param {Object}   props
 * @return {HTMLElement}
 */
const Button = (props) => {
	const {
		children,
		className,
		disabled = false,
		type = "button",
		render = "primary",
		small = false,
		isLoading = false,
		...rest
	} = props;

	const getLogo = () => {
		if (render !== "auth")
			return nothing;

		const logoPath = Utils.Common.imgPath("powernotes-circle-logo.png");

		return <img
			alt="PowerNotes Logo"
			src={logoPath}
			srcset={`${logoPath} 1x, ${Utils.Common.imgPath("powernotes-circle-logo@2x.png")} 2x`}
		/>;
	};

	return <button
		className={classnames(className, {
			"aa-btn-primary":   render === "primary",
			"aa-btn-secondary": render === "secondary",
			"aa-btn-link":      render === "link",
			"aa-btn-link-blue": render === "link-blue",
			"aa-btn-auth":      render === "auth",
			"aa-btn-small":     small,
			loading:            isLoading
		})}
		type={type}
		{...disabled && {disabled: "disabled"}}
		{...rest}
	>
		{getLogo()}
		{children}
		{(render === "primary" || render === "secondary")
			&& <span className="aa-btn-loading-dots">
				<span>.</span><span>.</span><span>.</span>
			</span>
		}
	</button>;
};

export default Button;
